/**
 * Etiqueta traducida de un valor del motor de relevancia (tipo de hecho,
 * estado o motivo de exclusión), con la llave `RELEVANCE.<prefix>.<value>`.
 * Un valor que el diccionario no conoce se muestra crudo: un tipo nuevo en el
 * backend no debe romper el dashboard.
 */
export function labelFor(intl, prefix, value) {
    if (!value) return value;
    const id = `RELEVANCE.${prefix}.${value}`;
    return intl.messages && intl.messages[id]
        ? intl.formatMessage({id})
        : value;
}

/**
 * Color fijo por tipo de hecho. Antes el color salía de la posición del tipo
 * en la lista de los que había en el rango, así que la misma serie cambiaba
 * de color según qué otros tipos aparecieran. Los seis primeros conservan el
 * color que tenían cuando estaban todos presentes.
 */
export const KIND_COLORS = {
    booking_created: '#28BBFF',
    hold_expired: '#00BB04',
    hold_released: '#FFBB28',
    hold_taken: '#FF8042',
    offer_listed: '#8884d8',
    price_changed: '#F08CFF',
    waitlist_joined: '#14B8A6',
};

const UNKNOWN_KIND_COLOR = '#9E9E9E';

export function colorForKind(kind) {
    return KIND_COLORS[kind] || UNKNOWN_KIND_COLOR;
}
